// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../css-loader/index.js??ref--6-2!./cropper.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../vue-style-loader/lib/addStylesClient.js")("03ea7902", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./~/cropperjs/dist/cropper.css
// module id = 516
// module chunks = 2